/**
 * 安全渲染工具 - 防止 XSS 攻击
 */
import DOMPurify from 'dompurify';

const purifyConfig = {
  ALLOWED_TAGS: [
    'a', 'b', 'i', 'u', 'em', 'strong', 'p', 'br', 'ul', 'ol', 'li',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'code',
    'span', 'div', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
    'img', 'hr', 'sup', 'sub', 'mark',
  ],
  ALLOWED_ATTR: [
    'href', 'target', 'rel', 'class', 'id', 'style',
    'src', 'alt', 'title', 'width', 'height',
    'colspan', 'rowspan',
  ],
  ALLOW_DATA_ATTR: false,
};

const svgPurifyConfig = {
  ALLOWED_TAGS: [
    'svg', 'path', 'circle', 'rect', 'line', 'polyline', 'polygon',
    'ellipse', 'g', 'defs', 'use', 'symbol', 'clipPath', 'mask',
    'linearGradient', 'radialGradient', 'stop', 'text', 'tspan',
  ],
  ALLOWED_ATTR: [
    'viewBox', 'fill', 'stroke', 'stroke-width', 'stroke-linecap',
    'stroke-linejoin', 'd', 'cx', 'cy', 'r', 'rx', 'ry', 'x', 'y',
    'x1', 'y1', 'x2', 'y2', 'width', 'height', 'points',
    'transform', 'opacity', 'class', 'id', 'style',
    'offset', 'stop-color', 'stop-opacity',
    'xlink:href', 'href', 'clip-path', 'mask',
  ],
  ALLOW_DATA_ATTR: false,
};

export function sanitizeHTML(dirty: string): string {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, purifyConfig);
}

export function sanitizeSVG(dirty: string): string {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, svgPurifyConfig);
}

export function sanitizeMarkdown(dirty: string): string {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ...purifyConfig,
    ALLOWED_TAGS: [
      ...purifyConfig.ALLOWED_TAGS,
      'input',
      'details', 'summary',
    ],
    ALLOWED_ATTR: [
      ...purifyConfig.ALLOWED_ATTR,
      'type', 'checked', 'disabled',
    ],
  });
}

export function escapeHTML(text: string): string {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

export function createSafeHTML(dirty: string): { __html: string } {
  return { __html: sanitizeHTML(dirty) };
}

export function createSafeSVG(dirty: string): { __html: string } {
  return { __html: sanitizeSVG(dirty) };
}

export function createSafeMarkdown(dirty: string): { __html: string } {
  return { __html: sanitizeMarkdown(dirty) };
}

export default {
  sanitizeHTML,
  sanitizeSVG,
  sanitizeMarkdown,
  escapeHTML,
  createSafeHTML,
  createSafeSVG,
  createSafeMarkdown,
};
